import * as loginApi from './login';
import * as loveqApi from './loveq';
import * as likeApi from './like';
import * as tourApi from './tour';
import * as sysApi from './sys';
import * as scheduleApi from './schedule';
import * as tencentApi from './tencent';
import * as carApi from './car';
import * as dslApi from './dsl';
import * as navigationApi from './navigation';

export {
  loginApi,
  loveqApi,
  likeApi,
  tourApi,
  sysApi,
  scheduleApi,
  tencentApi,
  carApi,
  dslApi,
  navigationApi,
};



// WEBPACK FOOTER //
// ./src/api/index.js